module.exports = __webpack_public_path__ + "img/avocadolachskugelcutted.310c2440.png";